import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, updateDoc, onSnapshot } from 'firebase/firestore';
import { useTranslation } from 'react-i18next';

export default function DoNotDisturbToggle({ roomId }) {
    const { t } = useTranslation();
    const [isDND, setIsDND] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [roomStatus, setRoomStatus] = useState(null);

    // 1. Real-time listener for room status
    useEffect(() => {
        if (!roomId) return;
        const roomRef = doc(db, 'rooms', roomId);
        const unsubscribe = onSnapshot(roomRef, (docSnap) => {
            if (docSnap.exists()) {
                const status = docSnap.data().status;
                setRoomStatus(status);
                setIsDND(status === 'DO_NOT_DISTURB');
            }
        }, (err) => {
            console.error("Error listening to room status:", err);
            setError(t('dnd.err_listener'));
        });

        return () => unsubscribe();
    }, [roomId, t]);

    // 2. Toggle Handler
    const handleToggleDND = async () => {
        if (!roomId) return setError(t('stay_mod.err_missing'));
        setLoading(true);
        setError(null);

        const newStatus = isDND ? 'occupied' : 'DO_NOT_DISTURB'; 

        try {
            const roomRef = doc(db, 'rooms', roomId);
            await updateDoc(roomRef, {
                status: newStatus,
            });
        } catch (err) {
            console.error("Failed to toggle DND:", err);
            setError(t('dnd.err_update'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="card" style={{ padding: '15px', backgroundColor: isDND ? '#fff0f0' : '#f9f9f9', borderLeft: isDND ? '5px solid red' : 'none', marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <strong style={{ color: isDND ? 'red' : 'inherit' }}>
                    {isDND ? `🛑 ${t('dnd.active')}` : t('dnd.inactive')}
                </strong>
                <button
                    onClick={handleToggleDND}
                    disabled={loading || !roomId}
                    style={{
                        backgroundColor: isDND ? '#dc3545' : 'var(--color-primary, #1e90ff)',
                        color: 'white',
                        padding: '10px 15px',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    {loading ? t('checker.searching') : (isDND ? t('dnd.btn_off') : t('dnd.btn_on'))}
                </button>
            </div>
            <p style={{ margin: '5px 0 0', fontSize: '0.9em', color: '#555' }}>
                {t('dnd.room_status')}: **{roomStatus ? t(`dnd.status_${roomStatus.toLowerCase()}`) : t('checker.searching')}**
            </p>
            {error && <p style={{ color: 'red', marginTop: '10px' }}>{t('checker.error_prefix')} {error}</p>}
        </div>
    );
}